import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'dva'
import { useHistory } from 'react-router-dom'
import { CheckCircleFilled } from '@ant-design/icons'
import './index.less'

const selector = ({ order }) => ({
  orderSuccessInfo: order.orderSuccessInfo,
})
export default function OrderSuccess() {
  const { orderSuccessInfo } = useSelector(selector, shallowEqual)
  const [time, setTime] = useState(4)
  const history = useHistory()

  const detailHandle = () => {
    history.push(`/mine/order-detail/${orderSuccessInfo.orderCode}`)
  }

  useEffect(() => {
    let timer = setTimeout(() => {
      if (time === 1) {
        clearTimeout(timer)
        history.push('/')
      } else {
        setTime(time - 1)
      }
    }, 1000)
  }, [time, history])

  return (
    <div className="order-success">
      <div className="o-s-content">
        <CheckCircleFilled className="o-s-icon" />
        <p className="o-s-success">下单成功，仓库正在处理</p>
        <p className="o-s-order">订单编号：{orderSuccessInfo?.orderCode}</p>
        <div className="o-s-buttons">
          <span className="o-s-btn" onClick={detailHandle}>
            查看订单详情
          </span>
          <span className="o-s-line"></span>
          <span
            className="o-s-btn"
            onClick={() => {
              history.replace('/')
            }}
          >
            继续逛逛
          </span>
        </div>
        <p className="o-s-jump">{time}s后将会自动跳转到企业采购平台首页</p>
      </div>
    </div>
  )
}
